export const COOKIES = 'isCookies'

export const setData = (key: string, data: string) => {
  localStorage.setItem(key, data)
}

export const getData = (key: string) => {
  return localStorage.getItem(key) || null
}
